export default __webpack_public_path__ + "static/controller-big-d1143403a2e809e9b9ecb8cc1e756175.svg";